import {Link} from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function PackMenu(){

const MenuCard = ({link,title,icon,color}) => (

<div className="col-xl-3 col-lg-4 col-md-6 mb-4">

<Link to={link} className="menu-link">

<div className="menu-card" style={{borderTop:`4px solid ${color}`}}>

<div className="menu-icon" style={{color:color}}>
<FontAwesomeIcon icon={icon} size="2x"/>
</div>

<p className="menu-title">{title}</p>

</div>

</Link>

</div>

);

return(

<section className="container-fluid mt-4">

<h5 className="menu-section-title">Package Management</h5>

<div className="row">

<MenuCard link="/add-pack" title="Add Package" icon="fa-solid fa-box" color="#0d6efd"/>

<MenuCard link="/pack-price" title="Package Price" icon="fa-solid fa-money-bill" color="#20c997"/>

<MenuCard link="/pack-lab" title="Lab Package" icon="fa-solid fa-flask" color="#6f42c1"/>

<MenuCard link="/pack-inv" title="Radiology Package" icon="fa-solid fa-x-ray" color="#fd7e14"/>

<MenuCard link="/pack-min" title="Minor Treatment Package" icon="fa-solid fa-bandage" color="#dc3545"/>

<MenuCard link="/pack-surgery" title="Surgery Package" icon="fa-solid fa-scissors" color="#0dcaf0"/>

<MenuCard link="/pack-room" title="Room Package" icon="fa-solid fa-bed" color="#198754"/>

<MenuCard link="/pack-request" title="OP Package Request" icon="fa-solid fa-file-medical" color="#6610f2"/>

<MenuCard link="/pack-request-ip" title="IP Package Request" icon="fa-solid fa-hospital-user" color="#ffc107"/>

</div>

</section>

)

}

export default PackMenu;